export const MAX_QUERY_RETRIES = 3

// react-query retry policy. A 4xx (including a 429 from the rate limiter) gets
// the same answer on a retry, so only network errors and 5xx are retried.
export const shouldRetryQuery = (failureCount, err) => {
  const status = err?.response?.status
  if (status >= 400 && status < 500) return false

  return failureCount < MAX_QUERY_RETRIES
}
